module.exports = __webpack_public_path__ + "img/logo.1a99fb4e.png";